<template>
  <div class="newHomePage">
    <!-- <van-loading size="24px">{{loadingText}}</van-loading> -->
    <div v-if="isTest" style="display: flex; justify-content: space-around; margin-top: 10px">
      <button @click="testClick(1)">绿道外</button>
      <button @click="testClick(2)">桂溪园区</button>
      <button @click="testClick(3)">锦城湖</button>
      <button @click="testClick(4)">缓存真实位置为:桂溪</button>
      <button @click="testClick(5)">清除缓存真实位置</button>
    </div>

    <div v-if="!isPageError">
      <loading v-if="isLoading"></loading>
      <div v-if="!isLoading">
        <!-- banner start -->
        <div class="banner_container">
          <div class="checkout_dialog" v-show="isShowCheckout">
            <div class="dialog_text">{{ scenicWillName }}</div>
            <div class="checkout_btn" v-show="isShowCheckoutBtn" @click="checkoutBtn">
              切换
            </div>
            <div class="close_dialog" v-show="isShowCloseBtn" @click="closeCheckout">
              <img src="../../assets/images/close_dialog.png" alt="" />
            </div>
          </div>
          <div class="arrow_dialog" v-show="isShowArrow && isShowCheckout"></div>
          <canvas-bg ref="canvasBg" name="canvas-bg" :height="340" :isVideo="bannerData.type == 1 ? false : true" :src="bannerData.content"></canvas-bg>
          <div class="banner_shadow"></div>
          <div class="topNav">
            <div class="topNav_left">
              <van-image class="location_icon" lazy-load :src="require('../../assets/img/locationIcon.png')" />
              <div @click="checkIn()">{{ locationName }}</div>
              <van-image @click="checkIn()" class="arrow_icon" lazy-load :src="require('../../assets/img/arrowIcon.png')" />
              <div class="temperature" @click="toWeather" v-if="weatherObj && weatherObj.weatherUrl">{{ weatherObj.temperature }}℃</div>
              <div @click="toWeather" v-if="weatherObj && weatherObj.weatherUrl">
                {{ weatherObj.events }}
              </div>
            </div>
            <div class="topNav_right">
              <van-image class="search" @click="toSearchPage" lazy-load :src="require('../../assets/img/searchIcon.png')" />
              <van-image class="scan" @click="callScan" lazy-load :src="require('../../assets/img/scanIcon.png')" />
            </div>
          </div>
          <div class="banner_text">
            <div>{{ bannerData.title }}</div>
            <div>{{ bannerData.secondTitle }}</div>
            <!-- <div>{{bannerData.title}}</div> -->
            <div class="banner_desc">{{ bannerData.subTitle }}</div>
          </div>
          <div class="icon_container">
            <swiper
              :options="{
                slidesPerView: 4.5,
                spaceBetween: 0,
                slidesOffsetAfter: 30,
              }"
              ref="mySwiper"
            >
              <swiper-slide class="swiper-slide" v-for="(item, index) in iconData" :key="index">
                <div class="icon_item" @click="iconClick(item.funName, item)">
                  <van-image :src="item.imageUrl">
                    <div></div>
                  </van-image>
                  <div class="icon_text">{{ item.funName }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <!-- banner end -->

        <div class="bottom_container">
          <div class="bottom_topBorder"></div>

          <!-- 公告通知 start -->
          <div class="notice_container" v-if="noticeData.length > 0">
            <van-notice-bar :left-icon="require('../../assets/img/notice_icon.png')" :scrollable="false" background="rgba(255,155,36,0.2)" color="#FF9B24">
              <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
                <van-swipe-item v-for="(item, index) in noticeData" :key="index" @click="noticeTo(item.articleId)">{{ item.noticeTitle }}</van-swipe-item>
              </van-swipe>
            </van-notice-bar>
          </div>
          <!-- 公告通知 end -->

          <!-- 特色功能区 start -->
          <div class="special_container">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="true" @change="swiperChange">
              <div slot="indicator" class="indicator_box" v-if="recommendFunArr.length > 1">
                <div class="indicator_line" v-for="(item, index) in recommendFunArr" :key="index" :class="{ indicator_active: index == IconIndex }"></div>
              </div>
              <van-swipe-item v-for="(item, index) in recommendFunArr" :key="index">
                <div class="special_card" :style="{ backgroundImage: `url('${item.imageUrl}')` }" @click="toCardMore(item.contentType, item)">
                  <!-- <div>{{ `url(${item.imageUrl})`}}</div> -->
                  <div class="card_title">{{ item.title }}</div>
                  <div class="card_desc">{{ item.subTitle }}</div>
                  <div class="btn_container">
                    <!-- <div class="card_btn">了解详情</div> -->
                    <!-- <div class="card_btn more" v-if="item.contentType == 3" @click="toCardMore(item.contentType)">了解该景点</div> -->
                  </div>
                </div>
              </van-swipe-item>
              <!-- 托底卡片 -->
              <!-- url("../../assets/img/greenWay_card.png") -->
              <van-swipe-item v-if="recommendFunArr.length == 0">
                <div class="special_card greenWayCard" @click="toCardMore('greenWay')">
                  <div class="card_title">这里是成都的花园----天府绿道</div>
                  <div class="card_desc">
                    简介、基本信息、发展历史、后续规划
                  </div>
                  <div class="btn_container">
                    <div class="card_btn">了解详情</div>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <!-- 特色功能区 end -->

          <!-- 必玩内容 start -->
          <div class="mustPlay_container" v-if="mustPlayArr.length > 0">
            <div class="mustPlay_title">
              <div class="title_left">热点推荐</div>
              <div class="title_right" @click="toAllList($event, 'mustPlay')">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <top-img :array="mustPlayArr" :slidesPerView="3.3" :spaceBetween="12" :imageWidth="102" :imageHeight="136" @itemClick="toMustPlayItem">
              <div slot="date"></div>
              <template slot-scope="data" slot="tags">
                <div class="tags_container_time" v-if="data.item.contentType == 8 || data.item.contentType == 7">
                  <div class="tags">
                    <img src="../../assets/img/time_icon.png" alt="" />
                    <div>{{ data.item.activityTime }}</div>
                  </div>
                </div>
                <div v-else>
                  <div class="tags_container" v-if="data.item.tags && data.item.tags.split(',').length > 0">
                    <div class="tags" v-for="(item, index) in data.item.tags.split(',')" :key="index">
                      {{ item }}
                    </div>
                  </div>
                </div>
              </template>
              <template slot-scope="data" slot="label">
                <div class="label_component">#{{ data.item.typeStr }}</div>
              </template>
              <div slot="address"></div>
            </top-img>
          </div>
          <!-- 必玩内容 end -->

          <!-- 主题路线 start -->
          <div class="recommend_container" v-if="recommendArr.length > 0">
            <div class="recommend_title">
              <div class="title_left">主题线路</div>
              <div class="title_right" @click="toAllList($event, 'recommend')">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <div class="tab_box" v-if="tabArray.length > 1">
              <tab-checkout :array="tabArray" :slideToClickedSlide="true" :activeIndex="tabActive" @itemClick="tabCheckout"></tab-checkout>
            </div>
            <top-img :isRecommend="true" :array="recommendArr" :slidesPerView="2.2" :spaceBetween="12" imageWidth="100%" :imageHeight="100" @itemClick="toRecommendItem">
              <template slot-scope="data" slot="date">
                <div class="label">
                  <div class="label_item" v-for="(item, index) in data.item.labels" :key="index">
                    {{ item.name }}
                  </div>
                </div>
              </template>
              <template slot-scope="data" slot="address">
                <div class="address" :style="{ display: data.item.distance ? '' : 'none' }">
                  {{ data.item.distance }}
                </div>
              </template>
              <template slot-scope="data" slot="tags">
                <div class="tags_container">
                  <div class="tags" v-for="(item, index) in data.item.tags.split(',')" :key="index">
                    {{ item }}
                  </div>
                </div>
              </template>
              <div slot="label" slot-scope="data">
                <div class="right_like">
                  全程{{ data.item.mileage ? data.item.mileage : 0 }}公里<span v-if="isShowDistance && distance(data.item.lat, data.item.lng).distance">&nbsp;&nbsp;|&nbsp;&nbsp;距你{{ distance(data.item.lat, data.item.lng).distance }}{{ distance(data.item.lat, data.item.lng).text }}</span>
                </div>
              </div>
            </top-img>
          </div>
          <!-- 主题路线 end -->

          <!-- 官方攻略 start -->
          <div class="strategy_container" v-if="strategyArr.length > 0">
            <div class="strategy_title">
              <div class="title_left">官方攻略</div>
              <div class="title_right" @click="toAllList($event, 'strategy')">
                <span>全部</span>
                <van-icon name="arrow" slot="left" />
              </div>
            </div>
            <left-img v-for="(item, index) in strategyArr" :item="item" @itemClick="toStrategyItem" :key="index"></left-img>
          </div>
          <!-- 官方攻略 end -->

          <!-- 发现绿道 start -->
          <div class="waterfall_container" ref="classify">
            <div class="waterfall_title">
              <van-sticky :offset-top="50" @scroll="stickyEvent">
                <div :class="{ waterfall_tagBox: isFixed }" :style="{ width: 'calc(100vw - 20px)', overflow: 'hidden' }">
                  <div v-if="classifyArray.length < 0" class="title_left">
                    发现绿道
                  </div>
                  <swiper
                    v-else
                    class="title_tag"
                    :options="{
                      setWrapperSize: false,
                      slidesPerView: 'auto',
                      slidesOffsetAfter: 70,
                    }"
                    ref="mySwiper"
                  >
                    <swiper-slide class="tag_item" :class="{ tag_item_active: waterfallIndex == index }" v-for="(item, index) in classifyArray" :key="index">
                      <div @click="waterfallTagClick(index, item.id)">
                        <div class="text">{{ item.tagName }}</div>
                        <div class="item_line"></div>
                      </div>
                    </swiper-slide>
                  </swiper>
                </div>
              </van-sticky>
            </div>
            <van-list
              :style="{
                position: 'relative',
                minHeight: clientHeight - 155 + 'px',
              }"
              v-if="!isEmptyData"
              :immediate-check="false"
              v-model="loading"
              @load="onLoad"
              :finished="finished"
              :finished-text="'没有更多了...'"
              :offset="450"
            >
              <div v-if="checkLoad" slot="loading" class="loading_box">
                <img src="../../assets/images/loading.gif" alt="" />
              </div>
              <div v-else slot="loading" class="loading_box_bottom">
                <div class="bottom_load">
                  <img src="../../assets/images/loading.gif" alt="" />
                  <div>加载中...</div>
                </div>
              </div>
              <Waterfall
                :reachBottomDistance="300"
                :list="waterfallData"
                :gutter="0"
                :breakpoints="{
                  500: {
                    rowPerView: 2,
                  },
                }"
                ref="waterfall"
                class="waterfall-box"
              >
                <template slot="item" slot-scope="props">
                  <div class="list-item" ref="listItem" @click="waterFallItem(props.data)">
                    <van-image v-if="props.data.imgUrl" radius="3px" class="item_left_img" :src="props.data.imgUrl" @load="$refs.waterfall.refresh()" />
                    <van-image v-else :width="listItemWidth" :height="116" radius="3px" class="item_left_img" :src="props.data.imgUrl" @load="$refs.waterfall.refresh()">
                      <!-- <template v-slot:error>
                    <div class="vanImage_load"></div>
                  </template> -->
                    </van-image>
                    <div class="labelAndLike">
                      <div class="waterfall_label">
                        #{{ props.data.typeStr }}
                        <van-image v-if="props.data.contentType == 6" :width="10" :height="10" class="live_icon" :src="require('../../assets/img/livePlay.png')" />
                      </div>
                      <div class="waterfall_like" v-if="props.data.count > 0">
                        <van-image :width="14" :height="14" class="item_left_img" :src="props.data.contentType == 6 ? require('../../assets/img/livePlay_icon.png') : require('../../assets/img/browse_icon.png')" />
                        <div class="like_num">
                          {{ props.data.viewCount ? props.data.viewCount : 0 }}
                        </div>
                      </div>
                    </div>
                    <div class="waterfall_item_title">
                      {{ props.data.title }}
                    </div>
                    <div class="user_info" v-if="props.data.username && props.data.avatar">
                      <van-image :round="true" :width="18" :height="18" class="item_left_img" :src="props.data.avatar" />
                      <div class="nickName">{{ props.data.nickName }}</div>
                    </div>
                  </div>
                </template>
              </Waterfall>
            </van-list>
            <van-empty v-else class="custom-image" :style="{ minHeight: clientHeight - 100 + 'px' }" :image="require('../../assets/img/data_empty.png')" description="暂无数据" />
          </div>
          <!-- 发现绿道 end -->
        </div>
        <div class="class-search" v-show="searchShow">
          <van-search :left-icon="require('../../assets/iconImage/ic_20_search@2x.png')" placeholder="请输入关键字" @click="toSearchPage" />
          <div @click="BackTop()">
            <a href="#">
              <van-image :src="require('../../assets/iconImage/ic_back@2x.png')" width="20px" height="15px"></van-image>
              <p style="font-size: 13px">回顶部</p>
            </a>
          </div>
        </div>
        <footer-tab :active="footerActive"></footer-tab>
      </div>
    </div>
    <page-error v-else></page-error>
  </div>
</template>
<script>
import Vue from "vue";
import FooterTab from "@/components/FooterTab";
import TopImg from "@/components/TopImgDownText";
import LeftImg from "@/components/LeftImgRightText";
import TabCheckout from "@/components/TabCheckout";
import CanvasBg from "@/components/CanvasBackground";
import Waterfall from "vue-waterfall-plugin";
import Loading from "@/components/loading";
import { getDistance } from "../../common/common";
import PageError from "../../components/PageError";
export default {
  data() {
    return {
      // banner 数据源
      bannerData: {
        title: "成都天府绿道",
        type: 1, //1 图片 2 视频
        subTitle: "来绿道享受这份悠闲", //副标题
        content: "http://www.baidu.com", // 背景资源地址
      },
      //天气对象
      weatherObj: {},
      // 区域对象
      cityInfo: {},
      // 是否显示固定顶部搜索
      searchShow: false,
      // icon 图标数据源
      iconData: [],
      // 公告数据源
      noticeData: [],
      // footer index
      active: 0,
      // 特色功能区数据
      recommendFunArr: [],
      // 必游数据源
      mustPlayArr: [],
      //主题路线 总数据
      allRecArr: {},
      // 主题路线 展示数据
      recommendArr: [],
      // 官方攻略数据源
      strategyArr: [],
      locationName: "获取中...",
      // 瀑布流数据源
      waterfallData: [],
      IconIndex: 0,
      // tab 选中下标
      tabActive: 0,
      // tab 数组
      tabArray: [],
      // 显示回到顶部的offsetTop阈值
      classifyTop: 0,
      scenicId: "",
      // 经纬度，虚拟定位会变为虚拟经纬度
      lat: "",
      lng: "",
      topic: "",
      pageIndex: 0,
      pageSize: 10,
      // 是否在加载中
      loading: true,
      // 是否已加载完成
      finished: false,
      // 瀑布流tag数据源
      classifyArray: [
        {
          id: "",
          tagName: "发现绿道",
        },
      ],
      // 瀑布流tag切换下标
      waterfallIndex: 0,
      // 列表数据是否为空
      isEmptyData: false,
      // 瀑布流item宽度
      listItemWidth: 0,
      //是否在绿道
      isGreenInWay: false,
      //是否显示loading图片
      isLoading: true,
      // 是否显示距离
      isShowDistance: false,
      isPageError: false,
      isFixed: false,
      // 缓存页面时的时间
      date: null,
      checkLoad: false,
      loadingText: "",
      scenicWillId: null, // 弹窗推荐切换的景区名称
      pollingTime: null, // 轮询计时器对象
      lastIsInGreen: false, // 上一次获取到的是否在绿道状态
      lastScenicId: "", // 上一次获取到的景区Id
      // 实时更新的经纬度
      latitudeWill: 0,
      longitudeWill: 0,
      isShowCheckout: false, // 是否显示弹窗
      scenicWillName: "定位显示您在“江家艺苑”，已为您切换场景", // 弹窗文本
      isShowCloseBtn: false, //是否显示弹窗关闭按钮
      isShowCheckoutBtn: false, //是否显示弹窗切换按钮
      isShowArrow: false, //是否显示弹窗箭头
      oldLat: 0, // 用于判断距离的第一次经纬度
      oldLng: 0,
      isTest: false,
      testLat: Number(sessionStorage.getItem("testLat")) || 0,
      testLng: Number(sessionStorage.getItem("testLng")) || 0,
      getLocationTimer: null,
      locationTimer: null,
    };
  },
  components: {
    FooterTab,
    TopImg,
    LeftImg,
    Waterfall,
    CanvasBg,
    TabCheckout,
    Loading,
    PageError,
  },
  activated() {
    // 路由缓存页面时触发此生命周期
    if (sessionStorage.getItem("isMo")) {
      // 手动换景外
      Object.assign(this.$data, this.$options.data()); // 重置data对象
      this.date = new Date();
      this.initPage();
      this.onLoad();
    } else {
      let routeId = sessionStorage.getItem("scenicId") || "";
      if (this.scenicId != routeId) {
        // 景区切换
        window.location.reload();
      } else {
        // 视频继续播放
        if (this.$refs["canvasBg"]) {
          this.$refs["canvasBg"].initbackground();
        }
        //位置重置
        this.$nextTick(() => {
          $(".newHomePage").get(0).scrollTop = sessionStorage.getItem("homeScroll");
        });
        let min = parseInt(((new Date().getTime() - this.date.getTime()) % (1000 * 60 * 60)) / (1000 * 60));
        if (min >= 5) {
          // 大于5分钟再更新
          this.initPage();
          this.onLoad();
          this.loopGetWaterData(this.pageIndex);
          this.date = new Date();
        }
      }
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    }
  },
  deactivated() {
    // 路由缓存页面停用时触发
    clearInterval(this.pollingTime); // 景区位置轮询定时器
    clearInterval(this.getLocationTimer); // 优化获取定位计时器
  },
  created() {
    this.isPageError = false;
    this.initPage();
    this.onLoad();
  },
  mounted() {
    this.date = new Date();
    $(".newHomePage")
      .get(0)
      .addEventListener("scroll", this.handleScroll);
    var isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isIOS) {
      // 不加 / 会出现ios页面回退 需要点击两次物理返回键
      window.history.pushState({}, "title", "#/");
    }
  },
  destroyed() {
    $(".newHomePage")
      .get(0)
      .removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    /**
     * 初始化页面
     */
    initPage() {
      setTimeout(() => {
        this.shareInit();
      }, 500);
      let longitude = sessionStorage.getItem("longitude");
      let latitude = sessionStorage.getItem("latitude");
      let scenicId = sessionStorage.getItem("scenicId") || "";
      this.scenicId = scenicId;
      // 是否选择了虚拟定位
      if (longitude && latitude) {
        this.getLocation()
          .then((res) => {
            this.lat = res.latitude;
            this.lng = res.longitude;
            // 更新缓存定位，用于详情页面获取进行距离计算
            sessionStorage.setItem("dislLat", res.latitude);
            sessionStorage.setItem("dislLng", res.longitude);
            this.getInitData(res.latitude, res.longitude, this.scenicId);
            this.getLocationName();
          })
          .catch((error) => {
            this.getInitData(latitude, longitude, this.scenicId);
          });
      } else {
        // 真实定位处理逻辑

        // 是否在微信浏览器下
        if (!this.isWeiXin()) {
          this.getInitData("", "", this.scenicId);
          return;
        }
        console.log(this.getLocation(), "this.getLocation()");
        this.getLocation()
          .then((res) => {
            console.log("已经获取定位");
            this.loadingText = "已经获取定位";
            this.lat = res.latitude;
            this.lng = res.longitude;
            // 保存这次的位置经纬度 用于判断距离
            this.oldLat = this.lat;
            this.oldLng = this.lng;
            // 更新缓存定位，用于详情页面获取进行距离计算
            sessionStorage.setItem("dislLat", res.latitude);
            sessionStorage.setItem("dislLng", res.longitude);
            let scenicId = this.scenicId;
            if (sessionStorage.getItem("isMo")) {
              // 手动切换绿道外位置
              scenicId = -1;
              sessionStorage.removeItem("isMo");
            }
            console.log(this.$route.params, "this.$route.params");
            console.log(scenicId, "scenicId");
            // 开启测试
            if (this.isTest) {
              if (this.testLat == 0 && this.testLng == 0) {
                this.testLat = res.latitude;
                this.testLng = res.longitude;
              }
              this.lat = this.testLat;
              this.lng = this.testLng;
              scenicId = null;
            }
            // 获取是否 在成都 参数
            this.getLocationName();
            // 初始化页面数据
            this.getInitData(this.lat, this.lng, scenicId, true)
              .then((res) => {
                this.judgeLocation(this.lat, this.lng)
                  .then((res) => {
                    let text = res.type == 0 ? "绿道" : res.type == 1 ? "A绿道-->B绿道" : res.type == 2 ? "外面-->绿道" : res.type == 3 ? "绿道-->外面" : "在绿道外";
                    // console.log(res.type,'res.type');
                    // console.log(!sessionStorage.getItem('onlyOne'),"!sessionStorage.getItem('onlyOne')")
                    if (res.type == 0 && !sessionStorage.getItem("onlyOne")) {
                      this.isShowCheckout = true; // 是否显示弹窗
                      this.scenicWillName = `定位显示您在${res.scenicName}，已为您切换场景`;
                      this.isShowCloseBtn = true;
                      this.isShowCheckoutBtn = false;
                      this.isShowArrow = true;
                      // 更新最后一次位置信息
                      this.lastIsInGreen = true;
                      this.lastScenicId = res.scenicId;
                      setTimeout(() => {
                        this.isShowCheckout = false;
                      }, 3000);
                      sessionStorage.setItem("onlyOne", "不再弹窗");
                    }
                    //开启轮询
                    this.pollingStart();
                  })
                  .catch((e) => {
                    console.log(e, "eeee");
                    this.$toast("初始判定场景失败");
                  });
              })
              .catch((error) => {
                console.log(error, "error");
                this.$toast("初始化数据失败");
              });
          })
          .catch((error) => {
            //用户未授权位置信息处理
            console.log(error, "getLocation错误信息");
            clearInterval(this.getLocationTimer);
            this.getInitData("", "", this.scenicId);
          });
      }
    },
    // 模拟测试
    testClick(type) {
      if (type == 1) {
        //绿道外
        this.testLat = 34.22259;
        this.testLng = 108.94878;
        this.lastScenicId = null;
      } else if (type == 2) {
        // 桂溪公园
        this.testLat = 30.56263;
        this.testLng = 104.06255;
        console.log(this.testLat);
        console.log(this.testLng);
        // this.testLat = 30.5667724609375;
        // this.testLng = 104.04736328125;
        // this.lastScenicId = '5e16bbe8da86270ad7b9ae91';
      } else if (type == 3) {
        //锦城湖
        this.testLat = 30.56979;
        this.testLng = 104.05453;
        // this.lastScenicId = '5e16bc39da86270ad7babfd0';
      } else if (type == 4) {
        sessionStorage.setItem("testLat", 30.56263);
        sessionStorage.setItem("testLng", 104.06255);
      } else if (type == 5) {
        sessionStorage.removeItem("testLat");
        sessionStorage.removeItem("testLng");
        sessionStorage.removeItem("onlyOne");
      }
      this.pollingStart();
    },

    //景区切换 弹窗按钮事件
    checkoutBtn() {
      this.lastScenicId = this.scenicWillId;
      this.lastIsInGreen = true;
      this.getInitData(this.lat, this.lng, this.scenicWillId);
      this.isShowCheckout = false;
      //更新详情页计算距离的缓存
      sessionStorage.setItem("dislLat", this.lat);
      sessionStorage.setItem("dislLng", this.lng);
      this.pollingStart();
    },

    /**
     * 隐藏切换景区的弹窗 且不再显示
     * @params isClear 是否清除轮询
     */
    closeCheckout() {
      this.isShowCheckout = false;
      // 清除计时器不再显示
      // clearInterval(this.pollingTime);
      //开启计时器
      this.pollingStart();
      //重置即将跳转的景区id 变量
      this.scenicWillId = null;
    },

    /**
     * 重置并开启计时器 轮询获取用户位置状态进行相应操作
     * @param time 计时器间隔60000*2   lat lng  测试使用经纬度参数
     */
    pollingStart(time = 60000 * 2, disNum = 0) {
      try {
        clearInterval(this.pollingTime);
        this.pollingTime = setInterval(() => {
          //获取经纬度
          wx.getLocation({
            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            altitude: true,
            success: (res) => {
              let lat = res.latitude;
              let lng = res.longitude;
              if (this.isTest) {
                lat = this.testLat;
                lng = this.testLng;
              }
              // 预保存---切换判定条件成功则准备切换到此经纬度
              this.latitudeWill = lat;
              this.longitudeWill = lng;
              // 判断距离
              console.log(`第一点经纬度:${this.oldLat},${this.oldLng}`);
              console.log(`第二点经纬度:${lat},${lng}`);
              let distance = getDistance(this.oldLat, this.oldLng, lat, lng).distance;
              if (distance > disNum) {
                console.log("距离判定通过!");
                //根据经纬度获取具体位置状态
                this.judgeLocation(lat, lng)
                  .then((res) => {
                    if ((res.type === 2 || res.type === 1) && this.scenicWillId != res.scenicId) {
                      // 外面->绿道   景区->景区   提示切换
                      clearInterval(this.pollingTime);
                      this.scenicWillName = `您已进入"${res.scenicName}"，是否切换至景区模式`;
                      this.scenicWillId = res.scenicId;
                      //弹窗显示
                      this.isShowCheckout = true;
                      this.isShowCloseBtn = true;
                      this.isShowCheckoutBtn = true;
                      this.isShowArrow = false;
                      setTimeout(() => {
                        //确保用户没有点击切换及X下进行此操作
                        if (this.isShowCheckout) {
                          this.closeCheckout();
                        }
                      }, 5000);
                    } else if (res.type === 3) {
                      console.log("由绿道走出来");
                      // 更新最后一次位置信息
                      this.lastIsInGreen = false;
                      this.lastScenicId = null;
                      //不允许使用运动助手
                    } else if (res.type === 4) {
                      console.log("在绿道外面");
                      // 更新最后一次位置信息
                      this.lastIsInGreen = false;
                      this.lastScenicId = null;
                    } else {
                      console.log("====判断用户位置状态未进行操作======");
                      console.log(res.type, "res.type");
                      console.log(this.scenicWillId != res.scenicId, "this.scenicWillId != res.scenicId");
                      console.log("===============End================");
                    }
                    // 更新位置信息
                    this.oldLat = this.latitudeWill;
                    this.oldLng = this.longitudeWill;
                  })
                  .catch((e) => {
                    console.log("轮询中judgeLocation出错");
                    console.log(JSON.stringify(e));
                  });
              } else {
                console.log(`距离小于${disNum}m!`);
              }
            },
            fail: function(res) {
              console.log("轮询中getLocation出错" + res);
              // this.$toast('轮询中getLocation出错');
            },
            cancel: function(res) {
              console.log("轮询中getLocation触发cancel" + res);
              // this.$toast('轮询中getLocation触发cancel');
            },
          });
        }, time);
      } catch (e) {
        console.log(e, "polling");
      }
    },

    /**
     * 粘性布局吸顶监听
     */
    stickyEvent({ scrollTop, isFixed }) {
      if (this.isFixed != isFixed) {
        this.isFixed = isFixed;
      }
    },

    /**
     * 根据经纬度判断用户当前位置
     * @params lat lng 经纬度
     * @return
     */
    judgeLocation(lat, lng) {
      return new Promise((resolve, reject) => {
        let requestData = {
          latitude: lat, //纬度
          longitude: lng, //经度
        };
        this.$request
          .get(`/appserver/v1/home/judging/user/range`, {
            headers: requestData,
          })
          .then((res) => {
            console.log("⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇judge接口返回数据⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇");
            console.log(JSON.stringify(res));
            console.log("⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇judge接口请求参数⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇");
            console.log(JSON.stringify(requestData));
            if (res.data.data) {
              let greenwayData = res.data.data;
              let infoData = {
                type: 0,
                scenicId: greenwayData.scenicId,
                scenicName: greenwayData.scenicName,
              };
              // 获取用户的上一次真实位置
              if (greenwayData.current == 1) {
                //在绿道中
                if (this.lastIsInGreen) {
                  //在绿道中使用产品
                  if (this.lastScenicId == greenwayData.scenicId) {
                    infoData.type = 0;
                    console.log("在绿道中使用产品");
                  } else {
                    //由一个绿道进入了另一个绿道
                    infoData.type = 1;
                    console.log("由一个绿道进入了另一个绿道");
                  }
                } else {
                  //从外面走进绿道
                  infoData.type = 2;
                  console.log("从外面走进绿道");
                }
              } else {
                //不在
                if (this.lastIsInGreen) {
                  //由绿道走出来
                  console.log("由绿道走出来");
                  infoData.type = 3;
                } else {
                  //在绿道外
                  console.log("在绿道外");
                  infoData.type = 4;
                  //暂时不做操作
                }
              }
              resolve(infoData);
            } else {
              console.log("res.data.data 为空");
            }
          })
          .catch((e) => {
            console.log("⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇judge接口请求参数⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇⬇");
            console.log(JSON.stringify(requestData));
            reject(e);
          });
      });
    },

    /**
     * list列表onload方法
     */
    onLoad() {
      this.pageIndex++;
      this.getWaterFallData();
    },
    /**
     * icon 区 item点击事件
     */
    iconClick(funName, item) {
      let type = item.skipNativeUrl;
      if (item.skipType == 1) {
        if (type === "scenicList") {
          // 景区列表
          this.$router.push({
            path: "/scenicParkList",
            query: {
              lat: this.lat,
              lng: this.lng,
            },
          });
          window.xm_bi.eventClick("click_icon_scenic");
        } else if (type === "greenwayCard") {
          //绿道名片
          this.$router.push({
            path: "/greenCard",
            query: {
              id: item.id,
              lat: this.lat,
              lng: this.lng,
            },
          });
        } else if (type === "complain") {
          // 投诉
          this.$router.push({
            path: "/complain",
            query: {
              greenwayIn: this.isGreenInWay ? 1 : 2, // 电话显示 限制场景
              scenicId: this.scenicId,
              latitude: this.lat, //
              longitude: this.lng, //
              cityLocation: this.cityLocation,
              scenicName: this.locationName,
            },
          });
          window.xm_bi.eventClick("click_icon_complain");
        } else if (type === "help") {
          //求助
          this.$router.push({
            path: "/oneSeekHelp",
            query: {
              scenicId: this.scenicId,
              greenwayIn: this.isGreenInWay ? 1 : 2, // 电话显示 限制场景
              latitude: this.lat,
              longitude: this.lng,
              cityLocation: sessionStorage.getItem("address"),
              scenicName: this.locationName,
            },
          });
          window.xm_bi.eventClick("click_icon_help");
        } else if (type === "activityEvent") {
          //活动赛事
          this.$router.push({
            path: "/activityList",
            query: {
              scenicId: this.scenicId,
              lat: this.lat,
              lng: this.lng,
            },
          });
          window.xm_bi.eventClick("click_icon_activity");
        } else if (type === "findParking") {
          // 找停车场
          this.$router.push({
            path: "/parking",
            query: {
              type: this.isGreenInWay ? 1 : 1, // 测试说不再受限制 工单号 ID1010973
            },
          });
          window.xm_bi.eventClick("click_icon_parking");
        } else if (type === "findwc") {
          // 找厕所
          this.$router.push({
            path: "/findWC",
            query: {
              wcName: this.cityLocation,
              wcId: this.scenicId,
            },
          });
          window.xm_bi.eventClick("click_icon_toilet");
        } else if (type === "scan") {
          // 扫一扫
          this.callScan();
        } else {
          this.$toast("敬请期待");
        }
      } else if (item.skipType == 2) {
        window.location.href = item.h5Url;
      } else {
        this.$toast("skipType等于3~");
      }
    },
    /**
     * 计算距离你多少距离
     * @params lat lng 景区 景点 经纬度
     */
    distance(lat, lng) {
      if (this.lat && this.lng) {
        let obj = getDistance(lat, lng, this.lat, this.lng);
        return { distance: obj.distance.toFixed(1), text: obj.type };
      } else {
        return { distance: "", text: "" };
      }
    },
    /**
     * 通知栏 点击事件
     * 跳转相应的公告页面
     */
    noticeTo(id) {
      this.$router.push({
        name: "noticeDetail",
        query: {
          id: id,
        },
      });
    },
    /**
     * 根据网址返回参数
     */
    getQueryVariable(url, name) {
      let a = document.createElement("a");
      a.href = url;
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = a.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    /**
     * 调用微信扫一扫
     */
    callScan() {
      // let str = "https://tapp-inner.tfgreenroad.com?latitude=30.561605&id=5f3de53d7072d341550354f7&type=10&longitude=104.067221";
      // let id = this.getQueryVariable(str, "id");
      // let type = this.getQueryVariable(str, "type");
      // let lat = this.getQueryVariable(str, "latitude");
      // let lng = this.getQueryVariable(str, "longitude");
      // this.toScanReturn(id, type, lat, lng);
      // return;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          console.log(result, "result");
          if (result) {
            let isScanPromise = this.isScanReturn(this.getQueryVariable(result, "i"));
            // let isScanPromise = this.isScanReturn('5f6cb87fb22901073108b8f2');
            isScanPromise
              .then((res) => {
                console.log(res, "rerere");
                if (res.data.ret == 0 && res.data.data != "") {
                  let str = res.data.data;
                  let id = this.getQueryVariable(str, "id");
                  let type = this.getQueryVariable(str, "type");
                  let lat = this.getQueryVariable(str, "latitude");
                  let lng = this.getQueryVariable(str, "longitude");
                  this.toScanReturn(id, type, lat, lng);
                } else {
                  this.$router.push({
                    name: "404",
                    query: {
                      tipText: "二维码非天府绿道提供，请检查一下再试试哦～",
                    },
                  });
                }
              })
              .catch((e) => {
                console.log(e, "eee");
                this.$router.push({
                  name: "404",
                  query: {
                    tipText: "二维码非天府绿道提供，请检查一下再试试哦～",
                  },
                });
              });
          } else {
            this.$toast("扫码失败，请重试");
          }
        },
      });
    },
    /**
     * 跳转至定位切换页
     */
    checkIn() {
      this.$router.push({
        path: "/switchScenic",
      });
    },

    /**
     * 扫一扫跳转页面   （type与小程序保持一致）
     */
    toScanReturn(id, type, latitude = 0, longitude = 0) {
      if (!id || !type) {
        return "";
      }
      // 餐饮 酒店
      if (type === "1" || type === "2") {
        this.$toast("暂不支持");
      }
      // 活动
      if (type === "7") {
        this.toDetail(7, id);
      }
      // 绿道名片
      if (type === "4") {
        this.toDetail(1, id);
      }
      // 景区名片
      if (type === "5") {
        this.toDetail(2, id);
      }
      // 景点名片
      if (type === "6") {
        this.toDetail(3, id);
      }
      // 厕所
      if (type === "10") {
        this.$router.push({
          path: "/wcDetail",
          query: {
            wc_id: id,
            latitude: latitude,
            longitude: longitude,
          },
        });
        // this.$router.push({
        //   path: "/findWC",
        //   query: {
        //     wcName: this.cityLocation,
        //     wcId: this.scenicId,
        //   },
        // });
      }
      // 停车场
      if (type === "11") {
        this.$router.push({
          path: "/parking",
          query: {
            type: 1, // 测试说不再受限制 工单号 ID1010973
          },
        });
      }
    },

    /**
     * 判断二维码是否是天府绿道的,不是则不跳转
     */
    isScanReturn(parami) {
      let data = new FormData();
      data.append("parami", parami);
      data.append("isApp", 0);
      console.log(parami, "parami");
      return this.$request.post("/appserver/v1/qrcode/scan", data);
    },
    /**
     * 点击 跳转搜索页
     */
    toSearchPage() {
      // wx.openLocation({
      //   latitude: 34.22259, // 纬度，浮点数，范围为90 ~ -90
      //   longitude: 108.94878, // 经度，浮点数，范围为180 ~ -180。
      //   name: '未知名', // 位置名
      //   address: '地址详情', // 地址详情说明
      //   scale: 12, // 地图缩放级别,整形值,范围从1~28。默认为最大
      //   infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      // })

      this.$router.push({
        path: "/bigSearch",
      });
      window.xm_bi.eventClick("click_home_search");
    },

    /**
     * 根据 type 跳转相应的详情页
     */

    toDetail(type, id) {
      this.ImagesFun.upLoad(type, 101, id);
      if (type == 3) {
        //景点
        this.$router.push({
          name: "scenicSpot",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 5) {
        // 线路
        this.$router.push({
          path: "/lineDetails",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 4) {
        // 攻略
        this.$router.push({
          path: "/strategyDetails",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 7) {
        // 活动
        this.$router.push({
          name: "activityDetails",
          query: {
            id: id,
          },
        });
      } else if (type == 2) {
        // 景区
        this.$router.push({
          name: "scenicParkDetail",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else if (type == 1) {
        // 绿道名片
        this.$router.push({
          path: "/greenCard",
          query: {
            id: id,
            lat: this.lat,
            lng: this.lng,
          },
        });
      } else {
        if (type == 8) {
          // 赛事
          this.$router.push({
            name: "qrcodePage",
            query: {
              src: this.SHDetails + id,
              title: "赛事",
            },
          });
          // window.location.href = this.SHDetails + id;
        }
      }
    },

    /**
     * 瀑布流item点击事件
     */
    waterFallItem(item) {
      this.toDetail(item.contentType, item.contentId);
    },
    /**
     * 天气 图标点击事件
     */
    toWeather() {
      if (this.weatherObj && this.weatherObj.weatherUrl) {
        window.location.href = this.weatherObj.weatherUrl;
      } else {
        this.$toast("未获取天气信息~");
      }
    },
    /**
     * 跳转全部列表事件
     */
    toAllList(event, name) {
      //console.log(name, 'allList');
      // 必玩列表
      if (name == "mustPlay") {
        this.$router.push({
          name: "mustPlayList",
          query: {
            scenicId: this.scenicId,
            lat: this.lat,
            lng: this.lng,
          },
        });
      }
      //主题线路
      if (name == "recommend") {
        this.$router.push({
          name: "lineList",
          query: {
            scenicId: this.scenicId,
            lat: this.lat,
            lng: this.lng,
            dataType: 1,
            tabId: this.tabArray.length > 1 ? this.tabArray[this.tabActive].id : "all",
          },
        });
      }
      // 官方攻略
      if (name == "strategy") {
        this.$router.push({
          name: "newStrategyList",
          query: {
            scenicId: this.scenicId,
          },
        });
      }
    },
    // 回到顶部
    BackTop() {
      this.bannerData = this.bannerData;
      this.searchShow = false;
      $(".newHomePage").get(0).scrollTop = 0;
    },
    /**
     * 卡片了解详情点击事件
     */
    toCardMore(type, item) {
      if (type == "greenWay") {
        // 特色功能区托底图跳转
        this.toDetail(1, "e5cd37bf9ef241b5bd4c326d6f3c702f");
        return;
      }
      // 直接跳转 (秦显成说的)
      if (item.hrefType == 1) {
        window.location.href = item.href;
        return;
      }
      let id = item.contentId;
      if (type == 8) id = item.id;
      // 特色功能区contentType值解释为下
      // :1绿道名片、2景区名片、3景点名片、4攻略、5线路、6-直播、7活动资讯、9餐饮、14-游记，,15-视频
      // 瀑布流跳转contentid值解释为下
      this.toDetail(type, id); // 3 景点  5 线路  4 攻略 7 活动  2 景区 1 绿道 8 赛事（赛事取id非contentId）
    },
    /**
     * 必有热玩item点击事件
     *
     */
    toMustPlayItem(id, item) {
      this.toDetail(item.contentType, item.contentId);
    },
    /**
     * 主题路线item点击事件
     */
    toRecommendItem(id, item) {
      this.$router.push({
        path: "/lineDetails",
        query: {
          id: item.id,
          lat: this.lat,
          lng: this.lng,
        },
      });
    },
    /**
     * 官方攻略item点击事件
     */
    toStrategyItem(id) {
      this.$router.push({
        path: "/strategyDetails",
        query: {
          id: id,
          lat: this.lat,
          lng: this.lng,
        },
      });
    },
    /**
     * swipe 切换change事件
     */
    swiperChange(event) {
      this.IconIndex = event;
    },
    /**
     * 调用getLocation获取真实经纬度
     */
    getLocation() {
      this.loadingText = "正在获取定位";
      let interVal = null;
      let num = 0;
      return new Promise((resolve, reject) => {
        interVal = setInterval(() => {
          wx.getLocation({
            type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            altitude: false, //返回高度信息， 为true会减慢接口时间
            success: (res) => {
              this.latitude = res.latitude;
              this.longitude = res.longitude;
              resolve({ latitude: res.latitude, longitude: res.longitude });
            },
            fail: function(res) {
              reject(res);
            },
            complete: function(res) {
              clearInterval(interVal);
            },
          });
          num = num + 1;
          if (num >= 4) {
            // 轮询四次都未获取到定位，则失败
            clearInterval(interVal);
            reject("获取定位失败");
          }
        }, 1500);
      });
      // return new Promise((resolve, reject) => {
      //   let that = this;
      //   let locationNum = 0;
      //   // 2秒内getLocation无响应重新请求
      //   this.getLocationTimer = setInterval(() => {
      //     console.error('重新触发获取定位');
      //     wx.getLocation({
      //       type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //       altitude: true,
      //       success: (res) => {
      //         this.latitude = res.latitude;
      //         this.longitude = res.longitude;
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         resolve({ latitude: res.latitude, longitude: res.longitude });

      //       },
      //       fail: function (res) {
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         reject(res);
      //       },
      //       complete: function (res) {
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         reject(res);

      //       }
      //     });
      //     locationNum++;
      //     if (locationNum > 4) {  // 循环三次无法获取到重新刷新浏览器
      //       clearInterval(this.getLocationTimer);
      //       clearTimeout(this.locationTimer);
      //       if (!this.latitude || !this.longitude) { // 经纬度依然没有获取到
      //         // console.log('最终刷新重试');
      //         // window.location.reload();
      //         // this.$toast('获取定位失败');
      //         this.getInitData('', '', this.scenicId);
      //         // this.getInitData('', '', this.scenicId);
      //       }
      //       // window.location.reload();
      //       // this.getInitData('', '', this.scenicId);
      //       // throw new Error("获取定位失败");
      //     }
      //   }, 2500)

      //   wx.ready(() => {
      //     wx.getLocation({
      //       type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      //       altitude: true,
      //       success: (res) => {
      //         this.latitude = res.latitude;
      //         this.longitude = res.longitude;
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         resolve({ latitude: res.latitude, longitude: res.longitude });
      //       },
      //       fail: function (res) {
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         reject(res);
      //       },
      //       cancel: function (res) {
      //         clearInterval(this.getLocationTimer);
      //         clearTimeout(this.locationTimer);
      //         reject(res);
      //       }
      //     });
      //   });
      //   wx.error(function (res) {
      //     reject(res);
      //   });

      //   this.locationTimer = setTimeout(() => {
      //     clearInterval(this.getLocationTimer);
      //     reject('获取定位超时');
      //   }, 3000)
      // });
    },
    /**
     * 首页数据请求
     * @params lat lng scenicId(景区id，手动切换绿道外id为-1)
     */
    getInitData(lat, lng, scenicId, isInitLast = false) {
      if (!lat && !lng) {
        // 未获取定位确保缓存经纬度无值
        sessionStorage.removeItem("dislLat");
        sessionStorage.removeItem("dislLng");
      }
      return new Promise((resolve, reject) => {
        let headers = {
          latitude: lat ? lat : "",
          longitude: lng ? lng : "",
        };
        let url = `/appserver/v1/home`;
        if (scenicId || scenicId == -1) {
          url = url + `?scenicId=${scenicId}`;
        }
        this.$request
          .get(url, { headers })
          .then((res) => {
            if (res.data.data) {
              let resData = res.data.data;
              // resData.current = 1;
              // 天气数据存在时
              if (resData.weather) {
                this.weatherObj = resData.weather;
              }
              // 区域数据存在时
              if (resData.cityInfo) {
                this.cityInfo = resData.cityInfo;
                if (sessionStorage.getItem("scenicId") || resData.current == 1) {
                  this.locationName = resData.scenicName;
                  if (!sessionStorage.getItem("scenicId")) {
                    sessionStorage.setItem("cityLocation", resData.cityInfo.districtName);
                  }
                } else {
                  this.locationName = resData.cityInfo.districtName;
                  sessionStorage.setItem("cityLocation", resData.cityInfo.districtName);
                }
              } else {
                if (resData.current == 1) {
                  this.locationName = resData.scenicName;
                  if (!sessionStorage.getItem("scenicId")) {
                    sessionStorage.setItem("cityLocation", resData.cityInfo.districtName);
                  }
                } else {
                  this.locationName = "地球";
                  sessionStorage.setItem("cityLocation", "我不在景区");
                }
              }
              // banner数据存在时
              if (resData.banner) {
                // banner 赋值
                this.bannerData = resData.banner;
              }
              // icon 数据存在时
              this.iconData = resData.funIcons ? resData.funIcons : [];
              // 公告通知
              this.noticeData = resData.notices ? resData.notices : [];
              let data = [6, 9, 14, 15, 12]; // 需要过滤的数据
              for (let i in resData.recommendFun) {
                //特色功能区过滤
                // console.log(data.indexOf(resData.recommendFun[i].contentType),'data.indexOf(resData.recommendFun[i].contentType)')
                if (data.indexOf(Number(resData.recommendFun[i].contentType)) != -1) {
                  resData.recommendFun.splice(i, 1);
                }
              }
              // 特色功能区
              this.recommendFunArr = resData.recommendFun ? resData.recommendFun : [];
              // 必玩热玩
              this.mustPlayArr = resData.plays ? resData.plays : [];
              // 线路标签对象
              if (resData.routeMap) {
                // 线路标签
                if (resData.routeMap.tags && resData.routeMap.tags.length > 0) {
                  if (Object.keys(resData.routeMap.maps).length != 0) {
                    this.allRecArr = resData.routeMap.maps;
                    // tab 标签数据源
                    if (this.tabArray.length <= 0) {
                      this.tabArray = this.tabArray.concat(resData.routeMap.tags);
                      this.recommendArr = resData.routeMap.maps["all"];
                    } else {
                      this.initCheckoutData(this.tabActive);
                    }
                  }
                } else {
                  // 无tab标签时
                  for (let k in resData.routeMap.maps) {
                    this.recommendArr = resData.routeMap.maps[k];
                  }
                }
              }
              this.strategyArr = resData.strategies ? resData.strategies : [];
              this.isGreenInWay = Boolean(resData.current); // 0为false 1为true  是否在绿道
              this.isLoading = false;
              // 初始化时保存一次，用于轮询时进行对比来判断用户位置状态变化
              if (isInitLast) {
                this.lastScenicId = resData.scenicId; //初始景区id
                this.lastIsInGreen = this.isGreenInWay; //初始 绿道状态
                console.log("------------已初始化景区id和绿道状态----------");
                console.log(this.lastScenicId, "this.lastScenicId");
                console.log(this.lastIsInGreen, "this.lastIsInGreen");
                console.log("---------------------------------------------");
              }
            } else {
              this.$toast("网络不稳定，请稍后重试");
            }
            console.log("getInitData");
            resolve("success");
          })
          .catch((e) => {
            console.log(e, "getInitData");
            // reject(e);
            this.isPageError = true;
          });
      });
    },

    /**
     * 初始化分享事件
     */
    shareInit() {
      if (!this.isWeiXin()) {
        return;
      }
      //console.log('初始化')
      wx.ready(() => {
        // eslint-disable-next-line
        //需在用户可能点击分享按钮前就先调用
        let imgDom = document.createElement("img");
        imgDom.src = require("../../assets/img/share_img.png");
        wx.updateAppMessageShareData({
          title: "天府绿道", // 分享标题
          desc: "首页", // 分享描述
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgDom.src, // 分享图标
          success: function() {
            // 分享成功
          },
        });
        wx.updateTimelineShareData({
          title: "天府绿道", // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgDom.src,
          success: function() {
            // 分享成功
          },
        });
      });
      wx.error(function(res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        // alert('error: ' + res);
      });
    },

    // 是否在微信环境下
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 瀑布流 tag点击事件
     */
    waterfallTagClick(index, id) {
      if (this.loading) {
        // 瀑布流列表加载中阻止切换
        return;
      }
      if (this.waterfallIndex != index) {
        this.waterfallIndex = index;
        this.isEmptyData = false;
        this.waterfallData = [];
        this.topic = id;
        this.pageIndex = 1;
        this.checkLoad = true;
        this.getWaterFallData()
          .then((res) => {
            setTimeout(() => {
              this.checkLoad = false;
            }, 300);
          })
          .catch((e) => {
            console.log(e);
            setTimeout(() => {
              this.checkLoad = false;
            }, 300);
          });
      }
    },

    /**
     * 路由缓存中更新瀑布流数据
     */
    loopGetWaterData(index) {
      //console.log('执行loop循环？');
      //console.log(this.topic, 'this.topic')
      let listData = [];
      let promiseArr = [];
      for (let i = 1; i <= index; i++) {
        promiseArr.push(
          new Promise((resolve, reject) => {
            this.$request
              .get(`/appserver/v1/home/recommends?scenicId=${this.scenicId}&topic=${this.topic}&pageIndex=${i}&pageSize=${this.pageSize}`)
              .then((res) => {
                if (res.data.ret == 0) {
                  // listData = listData.concat(res.data.data.items);
                  if (res.data.data.items) {
                    resolve(res.data.data.items);
                  }
                }
              })
              .catch((e) => {
                reject(e);
              });
          })
        );
      }
      Promise.all(promiseArr)
        .then((result) => {
          // 更新数据
          for (let i in result) {
            listData = listData.concat(result[i]);
          }
          //console.log(listData, 'listDatalistDatalistData')
          this.waterfallData = listData;

          // //console.log(result, 'listDatalistDatalistData');
        })
        .catch((e) => {
          //console.log(e, 'eeeeeee');
          // 错误处理
          window.location.reload();
        });
    },

    /**
     * 请求瀑布流列表数据
     */
    getWaterFallData() {
      return new Promise((resolve, reject) => {
        this.loading = true;
        this.finished = false;
        // console.warn(this.pageIndex, 'this.pageIndexthis.pageIndexthis.pageIndex')
        this.$request
          .get(`/appserver/v1/home/recommends?scenicId=${this.scenicId}&topic=${this.topic}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`)
          .then((res) => {
            if (res.data.ret == 0) {
              let resData = res.data.data;
              // 顶部tag标签动态获取
              if (this.classifyArray.length <= 1 && resData.topics) {
                for (let i in resData.topics) {
                  this.classifyArray.push({
                    id: resData.topics[i].id,
                    tagName: resData.topics[i].topicName,
                  });
                }
              }
              //console.log(this.classifyArray, 'classifyArray')
              // 列表数据获取
              resData = resData.items;
              if (resData) {
                let list = this.waterfallData;
                this.waterfallData = list.concat(resData);
              }
              // 数据为空
              if (this.pageIndex == 1 && (!resData || resData.length == 0) && this.waterfallData.length == 0) {
                //console.log('数据为空');
                setTimeout(() => {
                  this.loading = false;
                }, 300);
                // this.loading = false;
                this.finished = true;
                this.isEmptyData = true;
              }
              //   数据已加载完毕
              if (((!resData || resData.length == 0) && this.waterfallData.length > 0) || res.data.data.isBottomData == 1) {
                // 托底
                //console.log('数据已加载完毕');
                this.finished = true;
              }
              setTimeout(() => {
                this.loading = false;
              }, 300);
              // 图片懒加载色块宽度动态设置
              try {
                this.$nextTick(() => {
                  if (this.$refs.listItem) {
                    this.listItemWidth = this.$refs.listItem.clientWidth;
                  }
                });
              } catch (e) {
                //console.log('元素暂未渲染');
              }
              resolve("success");
              this.$nexttick(() => {
                window.scrollTo(0, 1);
                window.scrollTo(0, 0);
              });
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },

    /**
     * tab 标签点击事件
     */
    tabCheckout(data) {
      //console.log(data, 'tabcheckout');

      this.tabActive = data.index;
      if (data.id == "all") {
        // let allArray = [];
        // 循环遍历标签数据
        // for (let k in this.tabArray) {
        //   if (this.tabArray[k].id === 'all') {
        //     continue;
        //   } else {
        //     //  将map数据全部添加
        //     allArray = allArray.concat(this.allRecArr[`${this.tabArray[k].id}`]);
        //   }
        // }
        // let newSetData = this.unique(allArray);
        this.recommendArr = this.allRecArr["all"];
      } else {
        this.recommendArr = this.allRecArr[`${data.id}`];
      }
    },

    /**
     * 主题线路数据根据index 改变
     */

    initCheckoutData(index) {
      //console.log(this.tabArray, 'this.tabArray')
      // //console.log(this.allRecArr,'this.allRecArr')
      // //console.log(this.allRecArr[this.tabArray[index].id],'12312312312312312312312312312')
      this.recommendArr = this.allRecArr[this.tabArray[index].id];
    },

    /**
     * 复杂数据 去重
     */
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },
    //滚动到一定高度出现搜索
    handleScroll() {
      if (!this.$refs.classify) {
        return;
      }
      // console.log($('#app').scrollTop(),'scrollTop')
      let scrollTop = $(".newHomePage").scrollTop();

      this.scrollTop = scrollTop;
      // console.log(scrollTop,'scrollTop')
      if (this.classifyTop == 0) {
        this.classifyTop = this.$refs.classify.offsetTop;
      }
      if (this.scrollTop > 10) {
        this.searchShow = true;
      } else {
        this.searchShow = false;
      }
    },

    /**
     * 前端获取根据经纬度获取区域信息   ( 判断用户是否在成都市)
     */
    getLocationName() {
      $.ajax({
        type: "get",
        url: "https://apis.map.qq.com/ws/geocoder/v1/",
        dataType: "jsonp",
        data: {
          key: "LJKBZ-2WTRW-JT7RQ-OSONW-ZO6X7-ZMFMG", //开发密钥
          location: `${this.lat},${this.lng}`, //位置坐标
          get_poi: "1", //是否返回周边POI列表：1.返回；0不返回(默认)
          coord_type: "1", //输入的locations的坐标类型,1 GPS坐标
          output: "jsonp",
        },
        success: (data) => {
          // 在成都市内则显示item上的距离
          if (data.result.address_component.city == "成都市") {
            sessionStorage.setItem("isShowDistance", "true"); // 缓存一个布尔值为true的值
          } else {
            sessionStorage.removeItem("isShowDistance");
            // sessionStorage.setItem('isShowDistance', 'true');
          }
          // sessionStorage.setItem('isShowDistance', 'true');
          this.isShowDistance = Boolean(sessionStorage.getItem("isShowDistance"));
        },
      });
    },
  },
  computed: {
    // 屏幕高度
    clientHeight() {
      return document.body.clientHeight;
    },
    // 屏幕宽度
    clientWidth() {
      return document.body.clientWidth;
    },
  },
};
</script>
<style lang="scss">
.newHomePage {
  font-size: 15px;
  color: #333;
  // overflow-x: hidden;
  // banner区域  start
  width: 100%;
  height: 100%;
  background: #fff;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  left: 0;
  top: 0;
  overflow-x: hidden;
  // z-index: 999;
  .banner_container {
    position: relative;
    height: 340px;
    .checkout_dialog {
      font-size: 14px;
      position: absolute;
      top: 40px;
      left: 0px;
      width: calc(100% - 40px);
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      color: white;
      border-radius: 5px;
      box-sizing: border-box;
      z-index: 3;
      padding: 15px 0px;
      margin: 0 20px;
      justify-content: space-between;
      align-items: center;
      .dialog_text {
        // width: 80%;
        width: 75%;
        box-sizing: border-box;
        padding: 0 15px;
        flex-wrap: wrap;
        display: flex;
        flex: 1;
        align-items: center;
      }
      .checkout_btn {
        width: 64px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        box-sizing: border-box;
        //    padding: 2px 5px;
        border-radius: 13px;
        background-color: #2eba73;
        text-align: center;
        margin-right: 30px;
      }
      .close_dialog {
        margin-right: 15px;
        display: flex;
        align-items: center;
        .img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .arrow_dialog {
      position: absolute;
      top: 40px;
      left: 50px;
      // width: 20px;
      // height: 20px;
      border: 7px solid rgba(0, 0, 0, 0.5);
      border-right-color: transparent;
      border-bottom-color: transparent;
      transform: translateY(-50%) rotate(45deg);
      // background-color: rgba(0, 0, 0, 0.6);
      z-index: 0;
    }
    .topNav {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      display: flex;
      padding: 0 20px;
      box-sizing: border-box;
      justify-content: space-between;
      color: white;
      padding-top: 10px;
      font-size: 14px;
      z-index: 1;
      .topNav_left {
        display: flex;
        align-items: center;
        .temperature {
          margin: 0 8px;
        }
        .location_icon {
          img {
            width: 17px;
            height: 17px;
            transform: translateY(1px);
          }
          margin-right: 5px;
        }
        .arrow_icon {
          width: 17px;
          height: 17px;
        }
      }
      .topNav_right {
        display: flex;
        align-items: center;
        .search {
          margin-right: 8px;
        }
      }
      img {
        width: 20px;
        height: 20px;
      }
    }
    .banner_img {
      width: 100%;
      height: 100%;
    }
    .banner_shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 340px;
      // background: linear-gradient(to bottom, #ccc, black);   // 之前产品说的 上白下黑  注掉是因为有单子说视频模糊
      background: black;
      opacity: 0.2;
      z-index: 1;
    }
    .banner_text {
      position: absolute;
      top: 90px;
      left: 20px;
      z-index: 2;
      div {
        font-size: 29px;
        font-weight: 800;
        letter-spacing: 0.5px;
        color: white;
      }
      .banner_desc {
        font-size: 14px;
        font-weight: 400;
        transform: translateY(10px);
        color: #ffffff;
        opacity: 0.6;
      }
    }
    .icon_container {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100px;
      // display: -webkit-box;
      padding-left: 5px;
      box-sizing: border-box;
      overflow: hidden;
      .swiper-slide {
        text-align: center;
        font-size: 18px;
        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
        .icon_item {
          width: 95px;
          display: inline-block;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          img {
            width: 48px;
            height: 48px;
            margin-bottom: 5px;
            margin-top: 5px;
            border-radius: 50%;
          }
          .icon_text {
            font-size: 12px;
            font-weight: 400;
            color: white;
            letter-spacing: 0.5px;
          }
        }
      }
    }
  }
  // banner区域  end
  .bottom_container {
    position: relative;
    .bottom_topBorder {
      width: 100%;
      height: 10px;
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-100%);
      background: white;
      border-radius: 15px 15px 0 0;
      z-index: 2;
    }
    // 公告 start
    .notice_container {
      width: 90%;
      margin: 0 auto;
      padding-top: 10px;
      /deep/.van-notice-bar__left-icon {
        font-size: 15px !important;
      }
      .van-notice-bar {
        height: 30px;
        border-radius: 3px;
      }
      .notice-swipe {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        letter-spacing: 0.5px;
      }
    }
    // 公告 end

    // 特色功能区 start
    .special_container {
      // padding: 0 20px;
      // margin-top: 12px;
      // transform: translateY(12px);
      // margin-top: 12px;
      .my-swipe {
        // background: white;

        // padding: 10px 0px;
        // height: 120px;
        box-sizing: border-box;
        position: relative;
        // overflow: hidden;
        z-index: 3;
        .van-swipe-item {
          margin-top: 15px;
          margin-bottom: 15px;
        }
        .special_card {
          letter-spacing: 0.5px;
          margin: 0 auto;
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          padding: 20px 0px;
          padding-left: 20px;
          box-sizing: border-box;
          border-radius: 3px;
          height: 120px;
          // overflow: hidden;
          // rgba(0, 0, 0, 0.15)
          box-shadow: 0px -2px 15px 0px rgba(0, 0, 0, 0.15);
          border-radius: 3px;
          background-size: 100% 100%;
          padding-bottom: 0;
          .card_title {
            font-size: 16px;
            font-weight: 500;
            margin-top: 7px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .card_desc {
            font-size: 12px;
            color: #bfbfbf;
            margin-top: 8px;
            margin-bottom: 8px;
          }
          .btn_container {
            display: flex;
          }
          .card_btn {
            background: #00cb74;
            border-radius: 15px;
            font-size: 12px;
            text-align: center;
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 400;
            margin-right: 5px;
            padding: 4px 12px;
          }
          .more {
            background: white;
            border: 1px solid #00cb74;
            color: #00cb74;
          }
          .card_img {
            position: absolute;
            bottom: -10px;
            right: 0;
            width: 100px;
            height: 80px;
          }
        }
        .greenWayCard {
          background-image: url("../../assets/img/greenWay_card.png");
          background-size: 108% 122%;
          background-position: center center;
        }
        // 自定义指示器样式 start
        .indicator_box {
          position: absolute;
          left: 50%;
          bottom: 0px;
          transform: translateX(-50%);
          display: flex;
          .indicator_line {
            background: #e5e5e5;
            border-radius: 50%;
            width: 5px;
            height: 5px;
            margin-left: 6px;
          }
          .indicator_active {
            background: #2eba73;
            width: 10px;
            height: 5px;
            border-radius: 3px;
          }
        }
        // 自定义指示器样式 end
      }
    }
    // 特色功能区 end
    // swiper 滑动卡片样式 start
    .strategy_container {
      padding-right: 20px;
    }
    .mustPlay_container {
      padding-top: 25px;
      margin-top: 0px !important;
      .tags_container_time {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        // max-height: 20px;
        // overflow: hidden;
        margin-bottom: 4px;
        .tags {
          margin-right: 3px;
          padding: 0px 4px;
          background: rgba(0, 0, 0, 0.05);
          color: #787878;
          font-size: 11px;
        }
        .tags {
          display: flex;
          align-items: center;
          margin-top: 6px;
          border-radius: 2px;
          // height: 18px;
          img {
            width: 14px;
            height: 14px;
            margin-right: 2px;
          }
        }
      }
      .tags_container {
        margin-top: 6px;
      }
    }

    .mustPlay_container,
    .recommend_container,
    .delicacy_container,
    .strategy_container,
    .waterfall_container {
      margin-top: 40px;
      padding-left: 20px;
      // padding-right: 20px;
      box-sizing: border-box;
      .right_like {
        color: rgba(0, 0, 0, 0.5);
        font-size: 11px;
      }
      .van-sticky {
        // overflow-x: hidden;
        .waterfall_tagBox {
          background: white;
          padding: 0 20px;
          padding-bottom: 10px;
        }
      }
      .tags_container {
        display: flex;
        flex-wrap: wrap;
        // max-height: 20px;
        // overflow: hidden;
        margin-bottom: 4px;
        height: 16px;
        // line-height: 16px;
        align-items: center;
        overflow: hidden;
        .tags {
          margin-right: 3px;
          padding: 0px 4px;
          background: rgba(0, 0, 0, 0.05);
          color: #787878;
          font-size: 11px;
          display: flex;
          align-items: center;
          border-radius: 2px;
        }
      }
      .label_component {
        font-size: 11px;
        color: #2eba73;
        margin-top: 4px;
      }
      .mustPlay_title,
      .recommend_title,
      .delicacy_title,
      .strategy_title,
      .waterfall_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        margin-bottom: 20px;
        // overflow: auto;
        .title_left {
          font-size: 20px;
          font-weight: 400;
        }
        .title_right {
          display: flex;
          align-items: center;
          span {
            margin-right: 10px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
          }
        }
        .title_tag {
          display: flex;
          align-items: center;
          white-space: nowrap;
          width: 100%;
          // overflow-x: auto;
          ::-webkit-scrollbar {
            width: 0px;
          }
          .tag_item {
            margin-right: 30px;
            font-size: 16px;
            color: #787878;
            padding-bottom: 5px;
            cursor: pointer;
            width: initial;
            font-weight: 400;
            div {
              .text {
                padding-bottom: 4px;
              }
            }
          }
          .tag_item_active {
            font-size: 16px;
            color: #000000;
            position: relative;
            div {
              div {
                font-weight: bold;
              }
            }
            .item_line {
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translateX(-50%);
              width: 20px;
              height: 4px;
              background: #2ed07e;
              border-radius: 2px;
            }
          }
        }
      }
      .strategy_title {
        padding-right: 0;
      }
      .tab_box {
        margin-bottom: 20px;
      }
      .label {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.25);
        margin-top: 4px;
        display: flex;
        .label_item {
          background: rgba(97, 69, 247, 0.15);
          color: #6e5adb;
          margin-right: 4px;
          padding: 3px 4px;
        }
      }
      .address {
        font-size: 11px;
        color: rgba(0, 0, 0, 0.25);
        margin-top: 4px;
      }
    }
    // swiper 滑动卡片样式 end
    //瀑布流 start
    .waterfall_container {
      // position: relative;
      margin-top: 40px;
      .loading_box {
        position: absolute;
        top: 180px;
        left: 50%;
        transform: translateX(-50%);
        transition: 0s;
        width: 40px;
        height: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .loading_box_bottom {
        .bottom_load {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: #787878;
          img {
            width: 20px;
            height: 20px;
            margin-right: 2px;
          }
        }
      }
      .waterfall-box {
        .labelAndLike {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 11px;
          font-weight: 400;
          margin-top: 4px;
          .waterfall_label {
            color: #2eba73;
          }
          .waterfall_like {
            display: flex;
            align-items: center;
            .like_num {
              margin-left: 4px;
              color: #787878;
            }
            .like_afterNum {
              color: #ff504d;
            }
          }
        }
        .waterfall_item_title {
          font-size: 14px;
          font-weight: 900;
          color: #262626;
          margin-top: 4px;
          overflow-x: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .user_info {
          display: flex;
          margin-top: 6px;
          align-items: center;
          .nickName {
            margin-left: 6px;
            font-size: 11px;
            color: rgba(0, 0, 0, 0.5);
          }
        }
      }
    }

    //瀑布流 end
    .recommend_container {
      .tags_container {
        display: flex;
        height: 16px;
        // line-height: 16px;
        overflow: hidden;
        .tags {
          padding: 0px 4px;
          background: rgba(97, 69, 247, 0.15);
          color: #6145f7;
          margin-right: 5px;
          display: flex;
          align-items: center;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.waterfall_container {
  padding-right: 10px;
  .waterfall-box {
    width: 100%;
    // min-height: 200px;
    // 闪动动画覆盖处理
    .waterfull-item {
      transition: 0s;
      transition: none;
    }
    .list-item {
      width: 43vw;
      border-radius: 1%;
      margin-bottom: 20px;

      .vanImage_load {
        width: 100%;
        height: 186px;
        background: red;
      }
    }
  }
  // .fadeIn{
  //   animation-name: 'none';
  // }
}

.custom-image .van-empty__image {
  width: 245px;
  height: 170px;
}
// 回到顶部 start
.class-search {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  width: 100%;
  .van-search {
    padding: 10px 0;
    width: 80%;
    box-sizing: border-box;
    /deep/.van-search__content {
      border-radius: 19px;
      /deep/.van-cell {
        border-radius: 19px;
      }
    }

    .van-field__control {
      padding-left: 10px;
      width: 100%;
    }
  }
  .van-cell--borderless {
    width: 100% !important;
  }

  .van-search__content {
    background: rgba(241, 241, 241, 1);
    border-radius: 2px;
  }
  .van-cell {
    background: rgba(241, 241, 241, 1);
    border-radius: 2px;
  }
  .van-icon {
    color: #37384d;
    font-weight: 600;
  }
  .van-tabs__line {
    z-index: 2000;
  }
  & > div {
    &:nth-of-type(2) {
      a {
        display: inline-block;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 40px;
      }
    }
    .triangle {
      width: 0;
      height: 0;
      border-width: 0 7px 7px;
      border-style: solid;
      border-color: transparent transparent #37384d;
    }
    & > p {
      &:nth-of-type(2) {
        font-size: 12px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(85, 89, 89, 1);
        line-height: 17px;
        margin-top: 4px;
      }
    }
  }
}
// 回到顶部 end
</style>
